<template>
  <section class="sogdo-intro position-relative see__pad">
    <div class="sogdo-bg-pattern">
      <div
        class="sogdo-pattern-shape position-absolute"
        style="background-image: url('@/assets/images/shapes/shape-02.png')"
      ></div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <div class="sogdo-image-wrapper position-relative">
            <figure
              class="wow zoomIn animated"
              data-wow-delay="100ms"
              data-wow-duration="1500ms"
            >
              <img
                src="@/assets/images/resource/about-us.png"
                alt="Who We Are"
              />
            </figure>
            <div
              class="sogdo-stats-badge"
              style="
                background-image: url('@/assets/images/shapes/shape-01.png');
              "
            >
              <div class="sogdo-counter">
                <h1 class="sogdo-counter-text">
                  <span class="sogdo-counter-number">{{ content.stats.number }}</span><span>{{ content.stats.suffix }}</span>
                </h1>
              </div>
              <p>{{ content.stats.label }}</p>
            </div>
          </div>
        </div>
        <div class="col-lg-1"></div>
        <div class="col-lg-5 col-md-12">
          <div class="sogdo-content-wrapper">
            <div class="sogdo-section-label">
              <h4>{{ content.sectionLabel }}</h4>
            </div>
            <div class="sogdo-main-title">
              <h2>
                {{ content.mainTitle }} <span>{{ content.mainTitleHighlight }}</span>.
              </h2>
            </div>
            <div class="sogdo-description">
              <p>
                {{ content.description }}
              </p>
            </div>
            <div class="sogdo-cta-wrapper">
              <router-link :to="content.ctaLink" class="theme-btn theme-btn-one">
                <i class="icon-02"></i> {{ content.ctaText }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "HomeItsWoWeAreComp",
  props: {
    content: {
      type: Object,
      required: true,
      default: () => ({
        sectionLabel: "Who We Are",
        mainTitle: "Enhancing Real-world Experiences with",
        mainTitleHighlight: "Technology",
        description: "Sogdo is a cutting-edge tech & product company specializing in innovative solutions. We combine advanced technology with creative design to deliver exceptional digital experiences that transform how people interact with the world around them.",
        ctaText: "Learn More",
        ctaLink: "/about",
        stats: {
          number: "10",
          suffix: "K+",
          label: "World wide Client"
        }
      })
    }
  }
}
</script>

<style scoped>
/* Sogdo Intro Section Styles */
.sogdo-intro {
  padding: 80px 0;
  background: #00061a;
  position: relative;
}

.sogdo-intro .sogdo-bg-pattern {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
}

.sogdo-intro .sogdo-pattern-shape {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  opacity: 0.1;
}

.sogdo-intro .sogdo-image-wrapper {
  position: relative;
  z-index: 2;
}

.sogdo-intro .sogdo-image-wrapper figure {
  margin: 0;
  position: relative;
  overflow: hidden;
  border-radius: 20px;
}

.sogdo-intro .sogdo-image-wrapper figure img {
  width: 100%;
  height: auto;
  border-radius: 20px;
  transition: transform 0.3s ease;
}

.sogdo-intro .sogdo-image-wrapper figure:hover img {
  transform: scale(1.05);
}

.sogdo-intro .sogdo-stats-badge {
  position: absolute;
  bottom: 30px;
  right: 30px;
  background: #f6ec4f;
  padding: 20px;
  border-radius: 15px;
  text-align: center;
  min-width: 120px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.sogdo-intro .sogdo-counter {
  margin-bottom: 10px;
}

.sogdo-intro .sogdo-counter-text {
  font-size: 36px;
  font-weight: 700;
  color: #00061a;
  margin: 0;
  line-height: 1;
  font-family: "Archivo", sans-serif;
}

.sogdo-intro .sogdo-counter-text .sogdo-counter-number {
  font-size: 36px;
  font-weight: 700;
}

.sogdo-intro .sogdo-counter-text span:last-child {
  font-size: 24px;
  font-weight: 600;
}

.sogdo-intro .sogdo-stats-badge p {
  font-size: 14px;
  font-weight: 600;
  color: #00061a;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-family: "Open Sans", sans-serif;
}

.sogdo-intro .sogdo-content-wrapper {
  position: relative;
  z-index: 2;
  padding: 60px 0;
  margin-bottom: 30px;
}

.sogdo-intro .sogdo-section-label h4 {
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 13.2px;
  color: #f6ec4f;
  margin-bottom: 20px;
  font-family: "Archivo", sans-serif;
  text-transform: uppercase;
}

.sogdo-intro .sogdo-main-title h2 {
  font-size: 48px;
  font-weight: 700;
  line-height: 58px;
  color: #fff;
  margin-bottom: 30px;
  font-family: "Archivo", sans-serif;
}

.sogdo-intro .sogdo-main-title h2 span {
  color: #f6ec4f;
}

.sogdo-intro .sogdo-description p {
  font-size: 16px;
  line-height: 28px;
  color: #fff;
  margin-bottom: 40px;
  font-family: "Open Sans", sans-serif;
}

.sogdo-intro .sogdo-cta-wrapper {
  margin-top: 20px;
}

.theme-btn {
  display: inline-flex;
  align-items: center;
  padding: 15px 30px;
  background: #f6ec4f;
  color: #00061a;
  text-decoration: none;
  border-radius: 5px;
  font-family: "Archivo", sans-serif;
  font-weight: 600;
  transition: all 0.3s ease;
  margin: 20px 0;
}

.theme-btn i {
  margin-right: 10px;
  font-size: 16px;
  transition: transform 0.3s ease;
}

.theme-btn:hover i {
  transform: translateX(3px);
}

.theme-btn:hover {
  background: #e5d43f;
  color: #00061a;
  transform: translateY(-2px);
}

/* Responsive Design */
@media only screen and (max-width: 991px) {
  .sogdo-intro {
    padding: 80px 0;
  }
}

@media only screen and (max-width: 767px) {
  .sogdo-intro {
    padding: 60px 0;
  }
  .sogdo-intro .sogdo-content-wrapper {
    padding: 40px 0;
  }

  .sogdo-intro .sogdo-stats-badge {
    bottom: 10px;
    right: 10px;
    padding: 15px;
    min-width: 100px;
  }

  .sogdo-intro .sogdo-counter-text {
    font-size: 28px;
  }

  .sogdo-intro .sogdo-counter-text .sogdo-counter-number {
    font-size: 28px;
  }

  .sogdo-intro .sogdo-counter-text span:last-child {
    font-size: 20px;
  }

  .sogdo-intro .sogdo-main-title h2 {
    font-size: 36px;
    line-height: 46px;
  }
}

@media only screen and (max-width: 399px) {
  .sogdo-intro {
    padding: 40px 0;
  }
  
  .sogdo-intro .sogdo-main-title h2 {
    font-size: 28px;
    line-height: 38px;
  }

  .sogdo-intro .sogdo-section-label h4 {
    font-size: 16px;
    letter-spacing: 8px;
  }
}
</style>
